import { fontHeadings } from "../../../../enums/font";
import { loadFonts } from "../../../../utils/LoadSiteFonts";
import { IColorOverride } from "../../interfaces/IColorOverride";
import { overrideColorsToCssVars } from "../../utils/overrideColorsToCssVars";
import styles from "./ModernMonogramBadge.module.scss";

export interface IProps {
    eventLogo: IEventLogoModernMonogramBadge;
    type: "SITE" | "PRINT";
    cssVarsOnly: string;
}

export interface IPropsDemo {
    type: "DEMO";
    cssVarsOnly: string;
}

export interface IEventLogoModernMonogramBadge {
    name: "ModernMonogramBadge";
    name1: string;
    name2: string;
    colorText: IColorOverride;
    colorBackground: IColorOverride;
    fontSizeInitials: number;
    distanceInitialsY: number;
    distanceInitialsX: number;
}

export const ModernMonogramBadge = (props: IProps | IPropsDemo) => {
    const eventLogo: Omit<IEventLogoModernMonogramBadge, "name"> =
        props.type !== "DEMO"
            ? props.eventLogo
            : {
                  name1: "Victor",
                  name2: "Annika",
                  colorText: { override: false, color: null },
                  colorBackground: { override: false, color: null },
                  fontSizeInitials: 7,
                  distanceInitialsX: 6,
                  distanceInitialsY: 6,
              };

    const fontFamilyInitials = fontHeadings[22];
    const fontFamilyNames = fontHeadings[16];
    const fontSizeInitialsDefault = 35;
    const fontSizeInitials =
        eventLogo.fontSizeInitials === null ? fontSizeInitialsDefault : eventLogo.fontSizeInitials + 25; //25 to 40, standard 35

    const letterDistanceX = eventLogo.distanceInitialsX !== null ? eventLogo.distanceInitialsX : 0;
    const letterDistanceY = eventLogo.distanceInitialsY !== null ? eventLogo.distanceInitialsY : 7;
    const letterDistance = [letterDistanceX, letterDistanceY];

    const fontOffsetY = fontSizeInitials / 6;

    const letterPosition = [
        [50 - letterDistance[0], 50 + fontOffsetY - letterDistance[1]],
        [50 + letterDistance[0], 50 + fontOffsetY + letterDistance[1]],
    ];

    loadFonts([
        { font: fontFamilyInitials, type: "ONLY_400" },
        { font: fontFamilyNames, type: "ONLY_700" },
    ]);
    return (
        <div
            className={`${styles.wrapper} ${styles[props.type]} ${props.cssVarsOnly}`}
            style={overrideColorsToCssVars([
                { name: "text", colorOverride: eventLogo.colorText },
                { name: "background", colorOverride: eventLogo.colorBackground },
            ])}
        >
            <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <text
                    fontFamily={fontFamilyInitials}
                    x={letterPosition[0][0] + "%"}
                    y={letterPosition[0][1] + "%"}
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fontSize={fontSizeInitials}
                    className={styles.initial}
                >
                    {eventLogo.name1.slice(0, 1).toLocaleUpperCase()}
                </text>

                <text
                    fontFamily={fontFamilyInitials}
                    x={letterPosition[1][0] + "%"}
                    y={letterPosition[1][1] + "%"}
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fontSize={fontSizeInitials}
                    className={styles.initial}
                >
                    {eventLogo.name2.slice(0, 1).toLocaleUpperCase()}
                </text>
                <path
                    id="circlePathSecond"
                    fill="none"
                    strokeWidth="3"
                    className={styles.textColorStroke}
                    d="
                        M 90,50
                        a 1,1 0 1,0 -80,0
                        a 1,1 0 1,0 80,0
                    "
                />
                <path
                    id="circlePath"
                    fill="none"
                    d="
                        M 10, 50
                        a 40,40 0 1,1 80,0
                        a 40,40 0 1,1 -80,0
                    "
                />
                <text id="text">
                    <textPath
                        strokeWidth="8"
                        className={styles.backgroundColorStroke}
                        href="#circlePath"
                        textAnchor="middle"
                        startOffset="25%"
                        fontWeight="bold"
                        fontFamily={fontFamilyNames}
                    >
                        |{"#".repeat(eventLogo.name1.length)}|
                    </textPath>
                    <textPath
                        fontWeight="bold"
                        href="#circlePath"
                        textAnchor="middle"
                        startOffset="25%"
                        fontFamily={fontFamilyNames}
                    >
                        <tspan dy="3">{eventLogo.name1.toLocaleUpperCase()}</tspan>
                    </textPath>
                </text>
                <text id="text">
                    <textPath
                        strokeWidth="8"
                        className={styles.backgroundColorStroke}
                        href="#circlePathSecond"
                        textAnchor="middle"
                        startOffset="75%"
                        fontWeight="bold"
                        fontFamily={fontFamilyNames}
                    >
                        |{"#".repeat(eventLogo.name2.length)}|
                    </textPath>
                    <textPath
                        fontWeight="bold"
                        href="#circlePathSecond"
                        textAnchor="middle"
                        startOffset="75%"
                        fontFamily={fontFamilyNames}
                    >
                        <tspan dy="1">{eventLogo.name2.toLocaleUpperCase()}</tspan>
                    </textPath>
                </text>
            </svg>
        </div>
    );
};
